import { SMOOTH_SMOOTHER_API_URL } from "src/lib/constants"

/**
 * 契約に付ける印。請求停止と遅延ページで非表示は、どちらも「契約 ID を持つ行があれば設定済み」という同じ作りなので、
 * 画面は 1 つにして、扱う印をここで切り替える（仕様書の「2 つは同じ作りにする」）。
 */
export type ContractFlagKind = "debtConsolidated" | "guaranteed"

interface ContractFlagConfig {
  title: string
  /** 一覧から一括作成へ進むボタンの文言 */
  bulkLinkLabel: string
  /** 一括作成の実行ボタンの文言 */
  bulkSubmitLabel: string
  basePath: string
  endpoint: string
  /** 一覧の API が返す配列のキー */
  listKey: string
  /** 詳細の API が返すオブジェクトのキー */
  showKey: string
  bulkConfirmMessage: (count: number) => string
  bulkSuccessMessage: string
  deleteConfirmMessage: string
}

export const CONTRACT_FLAG_CONFIGS: Record<ContractFlagKind, ContractFlagConfig> = {
  debtConsolidated: {
    title: "請求停止をした契約",
    bulkLinkLabel: "一括請求停止",
    bulkSubmitLabel: "請求を停止する",
    basePath: "/admin/debt-consolidated-contracts",
    endpoint: `${SMOOTH_SMOOTHER_API_URL}/screen/debt_consolidated_contracts`,
    listKey: "debtConsolidatedContracts",
    showKey: "debtConsolidatedContract",
    bulkConfirmMessage: (count) => `${count}件の契約の請求を停止します。よろしいですか？`,
    bulkSuccessMessage: "の請求を停止しました",
    deleteConfirmMessage: "この契約の請求停止を解除します。よろしいですか？",
  },
  guaranteed: {
    title: "遅延ページで非表示にした契約",
    bulkLinkLabel: "一括で遅延ページで非表示にする",
    bulkSubmitLabel: "遅延ページで非表示にする",
    basePath: "/admin/guaranteed-contracts",
    endpoint: `${SMOOTH_SMOOTHER_API_URL}/screen/guaranteed_contracts`,
    listKey: "guaranteedContracts",
    showKey: "guaranteedContract",
    bulkConfirmMessage: (count) => `${count}件の契約を遅延ページで非表示にします。よろしいですか？`,
    bulkSuccessMessage: "を遅延ページで非表示にしました",
    deleteConfirmMessage: "この契約の遅延ページでの非表示を解除します。よろしいですか？",
  },
}

/** 詳細の API が返す行 */
export interface ContractFlag {
  id: number
  contractId: number
  createdAt: string
  updatedAt: string
}

/** 一覧の API が返す行。一覧で出す列だけを持つ */
export interface ContractFlagListItem {
  id: number
  contractId: number
  createdAt: string
}
